import { InjectionToken } from "@angular/core";
import { IAvailableAppsOverviewModalService } from "./i-available-apps-overview-modal.service";

export const availableAppsOverviewModalServiceInjectionToken: InjectionToken<IAvailableAppsOverviewModalService> = new InjectionToken<IAvailableAppsOverviewModalService>("digital-signage.user-dashboard.dashboard-web.AvailableAppsOverviewModalService");
